import { Component } from '@angular/core';

@Component({
    selector: 'app-content-container-title, [contentContainerTitle]',
    styleUrls: ['./content-container-title.component.scss'],
    template: '<ng-content></ng-content>',
    standalone: false
})
export class ContentContainerTitleComponent {}
